import { Button } from '@/components/Button';
import { ContactBox } from '@/components/ContactBox';
import { DisplayComponent } from '@/components/DisplayComponent';
import { Header } from '@/components/Header';
import { RemoteImage } from '@/components/RemoteImage';
import { ELoanUsage, setLoanUsage, setPaidAmount } from '@/context/borrower';
import { EDisplays, setDisplay } from '@/context/display';
import { useAppDispatch } from '@/context/storeHooks';

const baseId = 'screen-EmploymentIneligible';

export function EmploymentIneligible(): JSX.Element {
    // ***** Redux State *****
    const dispatch = useAppDispatch();

    // ***** Event Handlers *****
    function handleChangeLoanUsage(): void {
        dispatch(setPaidAmount(undefined));
        dispatch(setLoanUsage(ELoanUsage.PERSONAL));
        dispatch(setDisplay(EDisplays.QUICK_CALCULATOR));
    }

    return (
        <DisplayComponent baseId={baseId} data-testid={baseId}>
            <Header />
            {/* The sentence is what the customer needs; at 160px the mark
                pushed it below the fold on a phone. */}
            <div className='flex-center py-6 relative'>
                <div className='bg-primary h-24 w-24 rounded-full' />
                <RemoteImage fileName='coins.svg' className='absolute h-12' />
            </div>
            {/* One alignment and one spacing mechanism: the heading was
                centred over left-aligned copy, with spacing set on the
                container and on the children at once. */}
            <div className='max-w-lg mx-auto px-6 _flex flex-col gap-3'>
                <h3 className='text-xl text-primary font-bold'>
                    It looks like your employment status doesn’t qualify for a
                    novated lease.
                </h3>
                <p className='text-secondary'>
                    Novated leases require you to be:
                </p>
                <ul className='list-disc list-inside text-secondary'>
                    <li>A full-time or part-time employee.</li>
                    <li>Receiving a consistent salary.</li>
                    <li>Working for an employer who offers salary packaging.</li>
                </ul>
                <p className='text-sm text-textMuted'>
                    If you’re on a casual contract, self-employed, or your
                    employer doesn’t provide salary packaging, this option may
                    not be available.
                </p>
                <p className='text-sm text-textMuted'>
                    Still have questions? Contact us to discuss alternative
                    financing options.
                </p>
            </div>

            <div className='_flex space-x-2 mx-6 pt-6'>
                <Button
                    id={`${baseId}-button-reduceLoan`}
                    onClick={handleChangeLoanUsage}
                >
                    Change Loan to Consumer
                </Button>
            </div>

            <div className='flex-center w-full'>
                <ContactBox />
            </div>
        </DisplayComponent>
    );
}
